// Filtre les routes selon le rôle.
//  - `admin: true`      → route réservée à l'administrateur (masquée pour les analystes)
//  - `analyste: true`   → route propre aux analystes (masquée pour l'administrateur)
//  - `superAdmin: true` → route interne équipe Notit IA (masquée aux admins clients)
// Les catégories (avec `views`) sont conservées seulement si elles gardent au moins une vue visible.
// Les routes superAdmin restent MONTÉES (hidden) pour les autres rôles : le rôle est chargé en
// asynchrone, retirer la route du Switch casserait le refresh/deep-link (redirect prématuré) ;
// la vue porte sa propre garde et la RLS protège les données.
export function filterRoutes(routes, isAdmin, isSuperAdmin = false) {
  return routes
    .map((r) => {
      if (r.views) {
        const views = filterRoutes(r.views, isAdmin, isSuperAdmin);
        if (views.length === 0) return null;
        return { ...r, views };
      }
      if (r.superAdmin && !isSuperAdmin) return { ...r, hidden: true };
      if (r.admin && !isAdmin) return null;
      if (r.analyste && isAdmin) return null;
      return r;
    })
    .filter(Boolean);
}
